export default __webpack_public_path__ + "static/media/bn-blackfriday-cs.f5954d4e.jpg";